import {Component, EventEmitter, Inject, Injector, OnInit} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {AdminService} from "../../dashboard/services/admin.service";
import {BasePageComponentDirective} from "../../../_shared/base/base-page.component";
import {ParameterService} from "../../../_services/parameter.service";

@Component({
    selector: 'admin-user-modal',
    templateUrl: './admin-user.dialog.html',
    styleUrls: ['../../../scss/office.scss']
})
export class AdminUserDialog extends BasePageComponentDirective<any> implements OnInit {
    users: any[] = [];
    userRoles: any[] = [];
    products: any[] = [];
    ticketStatus: any = {};
    public result = new EventEmitter();
    override pageSize = 5;
    constructor(
        injector: Injector,
        public dialogRef: MatDialogRef<AdminUserDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private adminService: AdminService,
        private parameterService: ParameterService,
    ) {
        super(injector);
    }


    override async ngOnInit(): Promise<void> {
        super.ngOnInit();
        this.ticketStatus = await this.parameterService.getParameterByName("TICKET_STATUS");
        this.query();
        this.userRoles = await this.adminService.getAllUserRoles();
        this.products = await this.adminService.getAllProducts();
    }

    query(): void {
        this.pageQuery.sortBy = 'id';
        this.pageQuery.sortOrder = 'desc';
        this.pageQuery.size = 5;

        this.pageQuery.columns = ['fullName', 'email'];
        this.adminService.getAllUsers(this.pageQuery).then(r => {
            this.users = r.content;
            for(let i = 0; i < this.users.length; i++) {
                this.users[i]['role'] = this.users[i].roles.map((r: { name: any; }) => r.name).join(', ')
            }

            this.page.emit(r);
        });
    }

    chooseUser(user: any) {
        this.result.emit(user);
        this.dialogRef.close();
    }

    searchUser($event: any) {
        if ($event.key === 'Enter') {
            this.searchTerm = this.pageQuery.search;
            this.query();
        }
    }
}
